import React from 'react';

export default function CertifiedTable({
  orgs, total, page, limit, setPage, setLimit, search, setSearch
}) {
  return (
    <section className="micro-table-section">
      <div className="micro-table-container">
        <div className="micro-table-header">
          <div className="micro-table-entities">
            Show&nbsp;
            <select
              value={limit}
              onChange={e => { setLimit(Number(e.target.value)); setPage(1); }}
              className="micro-table-select"
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            &nbsp;entries
          </div>
          <div className="micro-table-searchbox">
            Search:&nbsp;
            <input
              type="text"
              placeholder="Search organizations..."
              value={search}
              onChange={e => { setSearch(e.target.value); setPage(1); }}
              className="micro-table-search"
            />
          </div>
        </div>
        <div className="micro-table-wrapper">
          <table className="micro-table">
            <thead>
              <tr>
                <th className="micro-th">Organization Name</th>
                <th className="micro-th">Industry</th>
                <th className="micro-th">No. of Employees</th>
                <th className="micro-th">Certification Period</th>
                <th className="micro-th">Company Profile</th>
              </tr>
            </thead>
            <tbody>
              {orgs.length === 0 ? (
                <tr>
                  <td colSpan={5} className="micro-td-center">No organizations found.</td>
                </tr>
              ) : orgs.map((org, idx) => (
                <tr key={idx}>
                  <td className="micro-td">{org.organization_name}</td>
                  <td className="micro-td">{org.industry}</td>
                  <td className="micro-td">{org.number_of_employees}</td>
                  <td className="micro-td">{org.certification_period}</td>
                  <td className="micro-td">
                    {org.profile_url ? (
                      <a
                        href={org.profile_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="micro-profile-btn"
                      >
                        View
                      </a>
                    ) : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="micro-table-footer">
          <div className="micro-table-info">
            {total > 0
              ? `Showing ${((page - 1) * limit) + 1} to ${Math.min(page * limit, total)} of ${total} entries`
              : 'Showing 0 to 0 of 0 entries'}
          </div>
          <div className="micro-pagination">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="micro-page-btn"
            >
              Previous
            </button>
            {Array.from({ length: Math.min(5, Math.ceil(total / limit)) }, (_, i) => {
              const pageNum = i + 1;
              return (
                <button
                  key={pageNum}
                  onClick={() => setPage(pageNum)}
                  className={`micro-page-btn${page === pageNum ? " active" : ""}`}
                >
                  {pageNum}
                </button>
              );
            })}
            {Math.ceil(total / limit) > 5 && (
              <>
                <span style={{
                  padding: "0 8px",
                  background: "#f5f5f5",
                  borderRadius: "4px",
                  color: "#222"
                }}>...</span>
                <button
                  onClick={() => setPage(Math.ceil(total / limit))}
                  className={`micro-page-btn${page === Math.ceil(total / limit) ? " active" : ""}`}
                >
                  {Math.ceil(total / limit)}
                </button>
              </>
            )}
            <button
              disabled={page === Math.ceil(total / limit) || total === 0}
              onClick={() => setPage(page + 1)}
              className="micro-page-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}